export default __webpack_public_path__ + "static/media/LuxoJR.3ab2eba4.png";